module.exports = __webpack_public_path__ + "img/ic_circle_yellow.ca667950.svg";